module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Medium.f3f4b1d0.woff2";